export class WaybillFailedTransactionMessageLoad {
  public static readonly type = '[WaybillFailedTransactionMessage] Load';
  constructor(public payload: string) {}
}

export class WaybillFailedTransactionMessageInitialState {
  public static readonly type = '[WaybillFailedTransactionMessage] Set initial state';
}
